// @flow
import createGetContent from './createGetContent';

const getContent = createGetContent('content');

export default getContent;



// WEBPACK FOOTER //
// ./src/api/content/getModerationContent.js